export enum FontSize {
  PX_4 = '0.25rem',
  PX_8 = '0.5rem',
  PX_12 = '0.75rem',
  PX_13 = '0.8125rem',
  PX_14 = '0.875rem',
  PX_16 = '1rem',
  PX_18 = '1.125rem',
  PX_20 = '1.25rem',
  PX_24 = '1.5rem',
  PX_25 = '1.5625rem',
  PX_28 = '1.75rem',
  PX_30 = '1.875rem',
  PX_31 = '1.9375rem',
  PX_32 = '2rem',
  PX_36 = '2.25rem',
  PX_39 = '2.4375rem',
  PX_40 = '2.5rem',
  PX_48 = '3rem',
  PX_49 = '3.0625rem',
  PX_56 = '3.5rem',
  PX_60 = '3.75rem',
  PX_61 = '3.8125rem',
  PX_70 = '4.375rem',
  PX_72 = '4.5rem',
  PX_75 = '4.688rem',
  PX_80 = '5rem',
}
